<template>
    <div>
        {{msg}}
    </div>
</template>
<script>
export default {
    data() {
        return {
            msg: ''
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm=> {
            console.log(vm.$route.query.code)
            if(vm.$route.query.code == '401'){
                vm.msg = "401,未授权，请登录"
            }else if(vm.$route.query.code == '400'){
                vm.msg = "400,错误请求"
            }else if(vm.$route.query.code == '403'){
                vm.msg = "403,拒绝访问"
            }else if(vm.$route.query.code == '404'){
                vm.msg = "404,请求错误,未找到该资源"
            }else if(vm.$route.query.code == '405'){
                vm.msg = "405,请求方法未允许"
            }
        })
        
    }
}
</script>
<style scoped>
 div{
     color: red;
     width:100%;
     height: 100px;
     line-height: 100p;
     text-align: center;
 }
</style>

